export default __webpack_public_path__ + "static/media/p6.9e6c073f.jpg";